import React, {forwardRef} from 'react';
import ClassNames from "../ClassNames";

import styles from './List.module.scss';

export interface Props {
    children: React.ReactNode;
    columns?: number;
    style?: React.CSSProperties;
    horizontal?: boolean;
}

export const List = forwardRef<HTMLDivElement, Props>(
    ({children, columns = 1, horizontal = false, style}: Props, ref) => {
        return (
            <div
                ref={ref}
                style={
                    {
                        ...style,
                        '--columns': columns,
                    } as React.CSSProperties
                }
                className={ClassNames(styles.List, horizontal && styles.horizontal)}
            >
                {children}
            </div>
        );
    }
);
